export default __webpack_public_path__ + "static/media/property_835.e26819dd.png";